import { Outlet } from 'react-router-dom';
import AdminNavbar from './AdminNavbar';

/*
  `max-w-screen-2xl` et non `container`. Le `container` de Tailwind plafonne
  par paliers : 1 024 px jusqu'à un écran de 1 279 px, 1 280 px jusqu'à
  1 535 px. Sur un portable courant, la page laissait donc des marges vides de
  part et d'autre pendant que ses tableaux défilaient (signalé le 9 octobre
  2026 sur l'écran des factures). Ici, la page prend la largeur de l'écran
  jusqu'à 1 536 px — le plafond qu'elle avait déjà sur un grand écran : aucune
  page ne devient plus large qu'elle ne l'était.
*/
const AdminLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminNavbar />
      <main className="mx-auto w-full max-w-screen-2xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
